/** Neutral copy shown after OTP request — does not reveal whether the account exists. */
export const MAGIC_LINK_SENT_MESSAGE =
  "If an account exists for this email, you'll receive a magic link shortly. Check your inbox.";

/**
 * Returns true when the OTP response should show the generic confirmation
 * rather than a Supabase error that could enable email enumeration.
 */
export function shouldConfirmMagicLinkSent(error) {
  if (!error) return true;
  const status = error.status ?? error.code;
  if (status === 429) return false;
  if (typeof status === "number" && status >= 500) return false;
  return true;
}

export function magicLinkErrorMessage(error) {
  if ((error?.status ?? 0) === 429) {
    return "Too many attempts. Please wait a few minutes and try again.";
  }
  return "Something went wrong. Please try again later.";
}

const AUTH_QUERY_PARAMS = new Set([
  "code",
  "state",
  "access_token",
  "refresh_token",
  "expires_in",
  "expires_at",
  "token_type",
  "type",
  "error",
  "error_description",
  "error_code",
]);

const AUTH_HASH_PARAMS = new Set([
  "access_token",
  "refresh_token",
  "expires_in",
  "expires_at",
  "token_type",
  "type",
  "provider_token",
  "provider_refresh_token",
]);

function filteredSearch(search) {
  const params = new URLSearchParams(search);
  let changed = false;
  for (const key of [...params.keys()]) {
    if (AUTH_QUERY_PARAMS.has(key)) {
      params.delete(key);
      changed = true;
    }
  }
  if (!changed) return search;
  const next = params.toString();
  return next ? `?${next}` : "";
}

function filteredHash(hash) {
  if (!hash || hash === "#") return hash;
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return "";
  const params = new URLSearchParams(raw);
  let changed = false;
  for (const key of [...params.keys()]) {
    if (AUTH_HASH_PARAMS.has(key)) {
      params.delete(key);
      changed = true;
    }
  }
  if (!changed) return hash;
  const next = params.toString();
  return next ? `#${next}` : "";
}

/** Remove auth tokens from the URL after Supabase establishes a session. */
export function stripAuthParamsFromUrl() {
  const { hash, search, pathname } = window.location;
  const nextSearch = filteredSearch(search);
  const nextHash = filteredHash(hash);
  if (nextSearch === search && nextHash === hash) return;
  window.history.replaceState({}, "", pathname + nextSearch + nextHash);
}
